import { useNotificationStore } from "../../../../Store/NotificationStore";
import { useEffect, useRef } from "react";
import "./TraffyTasksList.css";
import { claimTraffyTask } from "../../../../Services/Requests";
import { TraffyTask } from "../../types";

export const TraffyTasksList = ({
  setTasks,
}: {
  setTasks: React.Dispatch<React.SetStateAction<TraffyTask[]>>;
}) => {
  const traffyTasks = useRef<HTMLDivElement | null>(null);
  const { setNotification } = useNotificationStore();

  let rewardAmount = 0;
  let rewardType: string;

  useEffect(() => {
    const traffyTasksVal = traffyTasks.current;

    const onTaskLoad = (tasks: TraffyTask[]) => {
      console.log(tasks, "TASKS!!!!!");
      // Фильтруем задания, исключая те, у которых target равен "twitter"
      const filteredTasks = tasks.filter((task) => task.target !== "twitter");
      setTasks(filteredTasks);
    };
    const onTaskRender = (
      changeReward: (str: string) => void,
      changeCardTitle: (str: string) => void,
      changeButtonCheckText: (str: string) => void
    ) => {
      changeReward("Выполнить");
      changeCardTitle("");
      changeButtonCheckText("Проверить");
    };
    const onTaskReward = async (task: TraffyTask, signedToken: string) => {
      try {
        console.log("💰 Traffy SDK: Получена награда за задание", {
          task,
          signedToken,
        });

        const success = await claimTraffyTask(signedToken!);

        if (success) {
          if (success.rewards.amount) {
            rewardAmount = success.rewards.amount;
            rewardType = success.rewards.type || "tickets";

            const normalizedRewardType =
              rewardType === "ticket" ? "tickets" : rewardType;

            setNotification({
              type: "Success",
              message: "Награда за задание получена!",
              rewards:
                rewardAmount > 0
                  ? [{ amount: rewardAmount, type: normalizedRewardType }]
                  : undefined,
            });
          }

          setNotification({
            type: "Success",
            message: "Награда за задание получена!",
            rewards: [{ amount: 1, type: "tickets" }],
          });
          console.log("✅ Награда успешно получена:", success);
        }
      } catch (error) {
        console.error("❌ Ошибка при получении награды Traffy:", error);

        setNotification({
          type: "Error",
          message: "Ошибка при получении награды",
        });
      }
    };
    const onTaskReject = (task: any) => {
      setNotification({
        type: "Error",
        message: "Задание не выполнено.",
      });
    };
    //@ts-ignore
    window.Traffy.renderTasks(traffyTasksVal, {
      max_tasks: 10,
      exclude_targets: ["twitter"], // Попробуем исключить Twitter задания
      onTaskLoad,
      onTaskRender,
      onTaskReward,
      onTaskReject,
    });
  }, []);

  return <div className="traffyTasks" ref={traffyTasks}></div>;
};
